// extracted by mini-css-extract-plugin
export default {"elem_container":"StatElem_elem_container__wh4u1","none_select":"StatElem_none_select__8cV++","elem_text":"StatElem_elem_text__8NLg5"};